import { QuinnChatSummary } from "../../types";
import { formatChatTimestamp } from "../../utils/chatHistory.ts";

type ChatRowSize = "compact" | "comfortable";

const ROW_TEXT_CLASSES: Record<ChatRowSize, { title: string; meta: string; spacing: string }> = {
    compact: { title: "text-xs", meta: "text-[10px]", spacing: "mx-1 w-[calc(100%-0.5rem)] px-2 py-1.5" },
    comfortable: { title: "text-sm", meta: "text-xs", spacing: "w-full px-2.5 py-2" },
};

type ChatRowProps = {
    chat: QuinnChatSummary;
    isActive: boolean;
    onSelect: () => void;
    size?: ChatRowSize;
};

export function ChatRow({ chat, isActive, onSelect, size = "compact" }: ChatRowProps) {
    const classes = ROW_TEXT_CLASSES[size];
    return (
        <button
            type="button"
            onClick={onSelect}
            aria-current={isActive ? "true" : undefined}
            className={`${classes.spacing} flex items-baseline gap-2 rounded-lg text-left transition-colors ${
                isActive ? "bg-gray-100" : "hover:bg-gray-50"
            }`}
        >
            <span className="min-w-0 flex-1">
                <span className={`block truncate ${classes.title} ${isActive ? "font-medium text-gray-900" : "text-gray-800"}`}>
                    {chat.title}
                </span>
                <span className={`block truncate ${classes.meta} text-gray-400`}>{chat.businessLabel}</span>
            </span>
            <span className={`shrink-0 ${classes.meta} tabular-nums text-gray-400`}>{formatChatTimestamp(chat.updatedAt)}</span>
        </button>
    );
}
